module.exports = __webpack_public_path__ + "assets/img/hetongguanli.312dfb23.png";